// jquery.matchHeight-min.js v0.5.2 http://brm.io/jquery-match-height/ License: MIT
(function(d){var g=-1,e=-1,n=function(a){var b=null,c=[];d(a).each(function(){var a=d(this),k=a.offset().top-h(a.css("margin-top")),l=0<c.length?c[c.length-1]:null;null===l?c.push(a):1>=Math.floor(Math.abs(b-k))?c[c.length-1]=l.add(a):c.push(a);b=k});return c},h=function(a){return parseFloat(a)||0},b=d.fn.matchHeight=function(a){if("remove"===a){var f=this;this.css("height","");d.each(b._groups,function(a,b){b.elements=b.elements.not(f)});return this}if(1>=this.length)return this;a="undefined"!==
typeof a?a:!0;b._groups.push({elements:this,byRow:a});b._apply(this,a);return this};b._groups=[];b._throttle=80;b._maintainScroll=!1;b._beforeUpdate=null;b._afterUpdate=null;b._apply=function(a,f){var c=d(a),e=[c],k=d(window).scrollTop(),l=d("html").outerHeight(!0),g=c.parents().filter(":hidden");g.css("display","block");f&&(c.each(function(){var a=d(this),b="inline-block"===a.css("display")?"inline-block":"block";a.data("style-cache",a.attr("style"));a.css({display:b,"padding-top":"0","padding-bottom":"0",
"margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px"})}),e=n(c),c.each(function(){var a=d(this);a.attr("style",a.data("style-cache")||"").css("height","")}));d.each(e,function(a,b){var c=d(b),e=0;f&&1>=c.length||(c.each(function(){var a=d(this),b="inline-block"===a.css("display")?"inline-block":"block";a.css({display:b,height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css("display","")}),c.each(function(){var a=d(this),b=0;"border-box"!==a.css("box-sizing")&&
(b+=h(a.css("border-top-width"))+h(a.css("border-bottom-width")),b+=h(a.css("padding-top"))+h(a.css("padding-bottom")));a.css("height",e-b)}))});g.css("display","");b._maintainScroll&&d(window).scrollTop(k/l*d("html").outerHeight(!0));return this};b._applyDataApi=function(){var a={};d("[data-match-height], [data-mh]").each(function(){var b=d(this),c=b.attr("data-match-height")||b.attr("data-mh");a[c]=c in a?a[c].add(b):b});d.each(a,function(){this.matchHeight(!0)})};var m=function(a){b._beforeUpdate&&
b._beforeUpdate(a,b._groups);d.each(b._groups,function(){b._apply(this.elements,this.byRow)});b._afterUpdate&&b._afterUpdate(a,b._groups)};b._update=function(a,f){if(f&&"resize"===f.type){var c=d(window).width();if(c===g)return;g=c}a?-1===e&&(e=setTimeout(function(){m(f);e=-1},b._throttle)):m(f)};d(b._applyDataApi);d(window).bind("load",function(a){b._update(!1,a)});d(window).bind("resize orientationchange",function(a){b._update(!0,a)})})(jQuery);


jQuery(function($) {
    $(document).ready(() => {
        // Mobile Viewport
        $(function(){
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
            var ww = ( $(window).width() < window.screen.width ) ? $(window).width() : window.screen.width;
            var mw = 600;
            var ratio =  ww / mw; 
            if( ww < mw){ 
            $('#viewport').attr('content', 'initial-scale=' + ratio + ', maximum-scale=' + ratio + ', minimum-scale=' + ratio + ', user-scalable=yes, width=' + ww);
            } else { 
            $('#viewport').attr('content', 'initial-scale=1.0, maximum-scale=2, minimum-scale=1.0, user-scalable=yes, width=' + ww);
            }
            }
        });
        // Mobile Hamburger
        // $('.mobile_nav #navicon').click(function(){
        //     $(this).toggleClass('open');
        //     $('#menu-mobile-navigation').slideToggle();
        //     $('#menu-mobile-navigation').toggleClass('open');
        // });
        // Modify mobile menu
        $('.custom-back').each(function(){
            var backTxt = $(this).parent().closest('.is-drilldown-submenu-parent').find('> a').text();
            $(this).text(backTxt);
        });

        $('.open_list').on("click", function() {
            $('.category-select').slideToggle(100);
        });

        $('#toggle-view-by-links').on("click", function() {
            $('#view-by-links').slideToggle(100);
        });

        // Open first accordion item
        if ($(window).width() > 750) {
            $(window).load(function() {
                $('.mobile_products li.accordion-item:nth-child(1)').addClass('is-active');
            });
        }
        // Products to Show
        forcePageReloadOnSelectChange();
        function forcePageReloadOnSelectChange() {
            const selects = document.querySelectorAll("select.posts-per-page");
            for (const select of selects) {
                select.addEventListener("change", function () {
                    location.href = this.value;
                });
            }
        }
        // Bold first manual word
        $('.manual_title').each(function() {      
            var $bold = $(this); $bold.html($bold.html().replace(/^(\w+)/, '<strong>$1</strong>')); 
        });
        // Scroll down
        $('.category-select a[href^="#"]').on('click', function(event) {
            var target = $(this.getAttribute ('href') );
            if (target.length) {
                console.log("two");
              event.preventDefault();
              $('html, body').stop().animate( {
                scrollTop: target.offset().top -200
              }, 700);
            }
        });
        // Popup cookie nom nom
        var popup = new Foundation.Reveal($('#content-popup'));
		if ($.cookie && !$.cookie('true_popup')) {
            popup.open();
            $('#content-popup .close-button').click(function() {
                $('#content-popup').foundation('close');
                $.cookie('true_popup', 'true', {
                    expires: 365,
                    path: '/'
                });
            });
		}
        // Popup button to load arrow
        $('.content-popup .btn').on('click', function() {
			$('.intro').fadeOut(300);
            $('.swiper-popup-next').fadeIn(450);
		});
        // Close mobile accordions
        if ($(window).width() < 750) {
            $(".content-tabbed .accordion .accordion-item:nth-child(1)").removeClass( "is-active");
            $(".content-tabbed .accordion .accordion-content").attr("aria-hidden","true").css("display","none");
        }
        // Form submit spinner
        $("#serial-num-search").on("submit", function(){
            $(".spinner").fadeIn();
        });
        $(".tops-lookup").on("submit", function(){
            $(".spinner").fadeIn();
        });
        // Advanced Search toggle
        $('.toggle_search').click(function() {
			$('.search_box').toggleClass('open');
		});
        // Search Focus
        $('.menu-item-58').click(function() {
			$('.search_overlay').toggleClass('open');
			$('.search_overlay form input[type=search]').focus();
		});
        // Search Icon
        $('.fa-xmark').click(function() {
            $('.search_overlay').toggleClass('open');
        });
        // Search toggle
        $('.searchandfilter li').on('click', 'h4', function (e) {
            e.preventDefault();
            $(this).next().toggle('fast');
            $(this).toggleClass('open');
        });
        // Form toggle
        $("input[name='part-tracking']:radio").change(function() {
            $("#parts-order-form-order").toggle($(this).val() == "order");
            $("#parts-order-form-account").toggle($(this).val() == "account"); 
            $("#parts-order-form-postal-code").toggle($(this).val() == "zip"); 
        });
       
        // Match Height
        $('.swiper-container .swiper-slide').matchHeight();
        $('.content-products .desktop .product .border').matchHeight();
        //$('.search-filter-results .content-products .cell .border').matchHeight();
        $('.content-products .products .border').matchHeight();
        // Make Boxes Clickable
        $(".product .cell .border").click(function() {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        $(".cell.product .border").click(function() {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        $(".accordion-item .border").click(function() {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        $(".content-slider .swiper-slide").click(function() {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        // Kill Swiper
		if($(".swiper-slide").length === 1){
			swiper.destroy();
		  $(".swiper-prev",".swiper-next",".swiper-container-thumbs").css("display", "none");
		}
        // Clear Fields
        var el = $('input[type="text"], input[type="search"], textarea, input[type="email"], input[type="tel"]');
        el.focus(function(e) {
            if (e.target.value == e.target.defaultValue) e.target.value = '';
        });
        el.blur(function(e) {
            if (e.target.value == '') e.target.value = e.target.defaultValue;
        });   
    });
});
jQuery(function($) {
	// $(document).keyup(function(e) {
	// 	if (e.keyCode == 27) {
	// 		$('.search-form').removeClass('open').fadeOut(500);
	// 	}
	// });
    jQuery(function($) {
        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                $('.search_overlay').removeClass('open').fadeOut(500);
            }
        });
    });
    $(document).mouseup(function(e){
        var dropdown = $(".category-select");
        if(!dropdown.is(e.target) && dropdown.has(e.target).length === 0){
            dropdown.hide();
        }
    });
});